import { render, staticRenderFns } from "./PersonalizationMicrosoftSummary.vue?vue&type=template&id=58443652&scoped=true"
import script from "./PersonalizationMicrosoftSummary.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftSummary.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftSummary.vue?vue&type=style&index=0&id=58443652&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58443652",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58443652')) {
      api.createRecord('58443652', component.options)
    } else {
      api.reload('58443652', component.options)
    }
    module.hot.accept("./PersonalizationMicrosoftSummary.vue?vue&type=template&id=58443652&scoped=true", function () {
      api.rerender('58443652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/personalization/microsoft/PersonalizationMicrosoftSummary.vue"
export default component.exports